export const environment = {
      production: false,
  apiHost:"http://localhost",
  apiPort: 3000,
  loginWithPassword: true,
  firebaseConfig: {
    apiKey: "AIzaSyDi7MHDNv3hRy_1wfI86wST3kXQRql9E6E",
    authDomain: "acms-4db63.firebaseapp.com",
    projectId: "acms-4db63",
    storageBucket: "acms-4db63.firebasestorage.app",
    messagingSenderId: "707113278487",
    appId: "1:707113278487:web:1fa760864ae73748581052",
    measurementId: "G-4E6XGCE0LH",
    vapidKey: "BLj1CGEAnj4lO3o5Kc9LusvRmrw0L_I4oiTn0alGQb3OKtT8qLj2pI_NcXmjnbnjiUCBLVEQsyooKg_YIYa87CE"
  }
};

